var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"studyplan"},[_c('app-header',{attrs:{"title":_vm.title,"back-type":"back-app"}}),_c('studyplan-email'),_c('studyplan-list'),_c('studyplan-apply',{on:{"click":_vm.onClickPay}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }